const path = require('path')


// Переменные для узнавания Продакшн или Девелопер
const isProd = process.env.NODE_ENV === 'production'
const isDev = !isProd

// Названия файла при билдинге
const filename = ext => isDev ? `bundle.${ ext }` : `bundle.[hash].${ ext }`

module.exports = {
    publicPath: "/",
    assetsDir: 'static_for_front',
    transpileDependencies: ["vue-echarts", "resize-detector"],
    devServer: {
        disableHostCheck: true,
        proxy: {
            "^/api": {
                // target: "https://apiuniver6.cskz.kz",
                // target: "https://auca.studypage.biz",
                target: "http://localhost:10000",
                changeOrigin: true,
                compress: true,
            },
            "^/ws": {
                // target: "wss://apiuniver6.cskz.kz",
                // target: "wss://auca.studypage.biz",
                target: "ws://localhost:10000",
                ws: true,
                changeOrigin: true,
            }
        },
    },
    configureWebpack: {
        output: {
            filename: isDev ? 'test-study-page-[name].[hash:28].js' : '[name]-legacy.[hash:8].js',
        },
        // devtool: false,
        devtool: 'source-map',
    }
};
